import clsx from 'clsx';

export const replaceClassName = (
  classNameToReplace: string,
  replaceWith?: string
) => {
  return clsx(!replaceWith && classNameToReplace, replaceWith);
};
